"use client";

import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import { AuthCard } from "@/components/AuthCard";

export default function LoginPage() {
  const { status } = useSession();
  const router = useRouter();

  useEffect(() => {
    if (status === "authenticated") router.replace("/app");
  }, [status, router]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#EFEFEF] to-[#E6E4E4] flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex justify-center">
          <Link href="/">
            <Image
              src="/hirefitlogo-puzzle-rec.png"
              alt="HireFit"
              width={1800}
              height={945}
              className="h-9 w-auto"
              priority
            />
          </Link>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
          <h1 className="text-lg font-semibold text-gray-900 mb-5 text-center">Sign up or log in</h1>
          <AuthCard />
        </div>

        <p className="mt-4 text-center text-xs text-gray-500">
          By continuing, you agree to our{" "}
          <Link href="/terms" className="underline underline-offset-2 hover:text-gray-800">Terms</Link>{" "}
          and{" "}
          <Link href="/privacy" className="underline underline-offset-2 hover:text-gray-800">Privacy Policy</Link>.
        </p>
      </div>
    </div>
  );
}
